import AffiliatedFacPhyAPI from '../../../APIs/LoginAPI/AffiliatedFacPhyAPI'

export const RegionProvinceCity = {
    state: {
        regions: [],
        provinces: [],
        city: []
    },
    actions: {
    // For combobox display regions
        regions({ commit }) {
            AffiliatedFacPhyAPI.regions().then((res) => {
                commit('REGION', res && res.data ? res.data : [])
            })
        },

        // For combobox display province
        provinces({ commit }, region) {
            AffiliatedFacPhyAPI.provinces(region).then((res) => {
                commit('PROVINCES', res && res.data ? res.data : [])
            })
        },
        // For combobox display city
        cities({ commit }, city) {
            AffiliatedFacPhyAPI.cities(city).then((res) => {
                commit('CITIES', res && res.data ? res.data : [])
            })
        }
    },
    mutations: {
        REGION(state, regions) {
            state.regions = regions
        },
        PROVINCES(state, provinces) {
            state.provinces = provinces
        },
        CITIES(state, city) {
            state.city = city
        }
    },
    getters: {
        getRegions(state) {
            return state.regions
        },
        getProvinces(state) {
            return state.provinces
        },
        getCities(state) {
            return state.city
        }
    }
}
